import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';
import ReplayIcon from '@mui/icons-material/Replay';
import SyncIcon from '@mui/icons-material/Sync';

import RowActionsMenu from '../../../components/dashboard/RowActionsMenu';
import SoftChip from '../../../components/dashboard/SoftChip';
import { formatDateTime } from '../../../utils/formatters';

// Columns of the integration log: export_attempts (crm) or stock_sync_attempts (stock).
// The API orders by newest first and the grid pages on the server, so nothing sorts here.
export function buildLogColumns({ type, t, language, onRetry }) {
  const common = { sortable: false, filterable: false };
  const columns = [
    {
      ...common,
      field: 'created_at',
      headerName: t('integrations.log.columns.createdAt'),
      width: 170,
      valueFormatter: (value) => formatDateTime(value, language),
    },
    {
      ...common,
      field: 'success',
      headerName: t('integrations.log.columns.result'),
      width: 120,
      renderCell: ({ value }) => (
        <SoftChip
          size="small"
          color={value ? 'success' : 'error'}
          label={t(value ? 'integrations.log.success' : 'integrations.log.failure')}
        />
      ),
    },
    type === 'crm'
      ? { ...common, field: 'status_code', headerName: t('integrations.log.columns.statusCode'), width: 110 }
      : {
        ...common,
        field: 'step',
        headerName: t('integrations.log.columns.step'),
        width: 130,
        valueFormatter: (value) => t(`integrations.log.steps.${value}`),
      },
    {
      ...common,
      field: 'error_message',
      headerName: t('integrations.log.columns.error'),
      flex: 1,
      minWidth: 220,
      resizable: false,
    },
    {
      ...common,
      field: 'duration_ms',
      headerName: t('integrations.log.columns.duration'),
      width: 110,
      valueFormatter: (value) => (value == null ? '' : t('integrations.log.durationMs', { value })),
    },
  ];

  if (type === 'crm') {
    columns.push({
      ...common,
      field: 'lead_uuid',
      headerName: t('integrations.log.columns.lead'),
      width: 110,
      renderCell: ({ value }) => (
        <Link component={RouterLink} to={`/leads/${value}`} underline="hover">
          {t('integrations.log.viewLead')}
        </Link>
      ),
    });
  } else {
    columns.push({ ...common, field: 'total_items', headerName: t('integrations.log.columns.items'), width: 100 });
  }

  columns.push({
    ...common,
    field: 'actions',
    headerName: '',
    width: 56,
    disableColumnMenu: true,
    hideable: false,
    renderCell: ({ row }) =>
      !row.success && (
        <RowActionsMenu
          ariaLabel={t('integrations.log.actionsLabel')}
          actions={[
            {
              // crm replays this one export; stock has no per-try retry, so it syncs the row again.
              label: t(type === 'crm' ? 'integrations.log.retry' : 'integrations.log.sync'),
              icon: type === 'crm' ? <ReplayIcon fontSize="small" /> : <SyncIcon fontSize="small" />,
              onClick: () => onRetry(row),
            },
          ]}
        />
      ),
  });
  return columns;
}
